const name = "@justifi/webcomponents";
const version = "4.22.2";
const description = "JustiFi Web Components";
const collection = "dist/collection/collection-manifest.json";
const main = "dist/index.cjs.js";
const module = "dist/module/index.js";
const types = "dist/module/index.d.ts";
const repository = {
	type: "git",
	url: "git+https://github.com/justifi-tech/web-component-library.git"
};
const homepage = "https://storybook.justifi.ai/?path=/docs/introduction--docs";
const publishConfig = {
	registry: "https://registry.npmjs.org"
};
const files = [
	"dist/"
];
const scripts = {
	build: "stencil build --docs",
	dev: "stencil build --watch",
	lint: "eslint . --max-warnings 0",
	clean: "rm -rf .turbo && rm -rf node_modules && rm -rf dist",
	generate: "stencil generate",
	test: "TZ=utc stencil test --spec",
	"test:watch": "TZ=utc stencil test --spec --watchAll",
	"test:file": "stencil test --spec --watch --"
};
const dependencies = {
	"@popperjs/core": "^2.11.8",
	"@stencil/core": "^4.0.5",
	"@stencil/store": "^2.0.8",
	bootstrap: "^5.2.3",
	"chart.js": "^4.4.1",
	"date-fns": "^2.29.3",
	"dinero.js": "^1.9.1",
	"iframe-resizer": "^4.3.7",
	imask: "^7.6.0",
	lodash: "^4.17.21",
	rxjs: "^7.8.1",
	"ts-dedent": "^2.2.0",
	uuid: "^9.0.0",
	yup: "^1.0.0"
};
const devDependencies = {
	"@babel/preset-env": "^7.21.5",
	"@babel/preset-react": "^7.18.6",
	"@babel/preset-typescript": "^7.21.5",
	"@rollup/plugin-replace": "^6.0.1",
	"@stencil/sass": "^3.0.1",
	"@types/jest": "27.0.3",
	"@types/react": "^18.0.37",
	"@types/react-dom": "^18.0.11",
	dotenv: "^16.3.1",
	jest: "^29.7.0",
	"jest-cli": "^29.7.0",
	"jest-environment-node": "^29.7.0",
	"ts-jest": "^29.1.2"
};
const license = "MIT";
const gitHead = "507bac1d941eae6e1f56e185ecd9bc9d22637783";
const packageJson = {
	name: name,
	version: version,
	description: description,
	collection: collection,
	main: main,
	module: module,
	types: types,
	repository: repository,
	homepage: homepage,
	publishConfig: publishConfig,
	files: files,
	scripts: scripts,
	dependencies: dependencies,
	devDependencies: devDependencies,
	license: license,
	gitHead: gitHead
};

export { packageJson as p };
